/**
 * Convenience method to push to GTM's data layer
 * @param {*} data - The data to push to GTM's data layer
 */
export default function pushDataLayer(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}
